import {useEffect, useMemo, useRef} from "react";
import * as Tone from "tone";
import { useStore } from "@hmpu/powerups.store";

const audioCtx = new Tone.Context({
    latencyHint: "interactive",
    sampleRate: 44100,
});
Tone.setContext(audioCtx);

let sounds = [],
    gainNodes = []

const useVolumeControl = () => {

    const currentVolume = useStore((state) => state.currentVolume);

    const dynamicRange = 70;

    /*const calculateGain = (val) => Math.max(0, Math.min(1, (val)/dynamicRange * .75));*/
    const calculateVolume = (val) => {
        return (dynamicRange * (val / 100)) - dynamicRange;
    }

    useEffect(() => {

    },[])

    const connectSound = (sound) => {

            const context = Tone.getContext();

            if (sound instanceof HTMLMediaElement && !sounds.includes(sound)) {
                sounds.push(sound);
                let mediaElement = context.createMediaElementSource(sound)
                const gainNode = context.createGain({
                    units: "decibels"
                });
                gainNode.gain.value = 1;///calculateGain(currentVolume);
                mediaElement.connect(gainNode)
                Tone.connect(gainNode, context.destination)

            } else if ((sound.constructor.name == "Players") || (sound.constructor.name == "Player")) {
                //sound.volume.value = (calculateVolume(currentVolume));
                //Tone.connect(sound, audioCtx.destination)
                sound.connect(context.destination)
            }

            //
        //}
   }

    const removeSound = (sound) => {
        /*const idx = sounds.indexOf(sound)
        if(idx >= 0){
            sounds.splice(idx,1)
            gainNodes.splice(idx, 1)
        }*/
    }

    const setVolume = (value) => {
        const vol = calculateVolume(value)
        Tone.getContext().destination.volume.value = vol
        Tone.getContext().destination.mute = (vol < -60)

        console.log("Volume: ", value)
    }

    return {
        connectSound: connectSound,
        removeSound: removeSound,
        setVolume:setVolume
    }

}

export default useVolumeControl;
